import Logo from './logo-component'

export default Logo
